import { CRUDMutations } from '@/utils/store-utilities'

const defaultItem = (item) => ({
  ...item,
})

export const state = () => ({
  items: [],
})

export const mutations = {
  ...CRUDMutations(defaultItem),
}

export const getters = {}

export const actions = {
  removeTickets({ commit }, item) {
    return this.$axios.$delete(`admin/tickets/${item.id}`).then((response) => {
      if (response.data) {
        commit('remove', item)
      }
    })
  },
  fetchTicket({ commit }, id) {
    return this.$axios.$get(`admin/tickets/${id}`).then((response) => {
      return response.data
    })
  },
  fetchTicketss({ commit }) {
    return this.$axios.$get('admin/tickets').then((response) => {
      commit('load', response.data)
    })
  },

  /**
   * Fetch all distinct events for tickets
   * @returns {Promise<Array>}
   */
  fetchEvents() {
    return this.$axios.$get('admin/tickets/events').then((response) => {
      return response.data || response
    })
  },
}
